import { render, staticRenderFns } from "./MPjhTable.vue?vue&type=template&id=c2d5fdf2&scoped=true"
import script from "./MPjhTable.vue?vue&type=script&lang=js"
export * from "./MPjhTable.vue?vue&type=script&lang=js"
import style0 from "./MPjhTable.vue?vue&type=style&index=0&id=c2d5fdf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d5fdf2",
  null
  
)

export default component.exports